export default {
  FETCH_APPLICATIONS: "FETCH_APPLICATIONS",
  FETCH_APPLICATION_DETAILS: "FETCH_APPLICATION_DETAILS",
};
